module.exports = __webpack_public_path__ + "img/icon_robot.f425debf.png";